<section class="multiHeaderRought"
  *ngIf="!(loaderService.isLoading | async) && multiCityFlightData && multiCityFlightData.length > 0">
  <ul>
    <ng-container *ngFor="let response of multiCityFlightData">
      <!-- class="active"  -->
      <li *ngFor="let item of response.flightjourneys[0].flightlegs">
        {{item[0].origin_name}}
        <img src="../../../../assets/svgIcon/arrow_long_right_b.svg" alt="" class="img-fluid">
        {{item[item.length-1].destination_name}}
      </li>
    </ng-container>
  </ul>
</section>

<ng-container *ngIf="loaderService.isLoading | async">
  <div class="pageLoader">
    <div class="layoutLoader">
      <h3>Please Wait...</h3>
      <div class="loaderContent">
        <div class="springLoader">
          <mat-spinner [diameter]="48"></mat-spinner>
        </div>
        <p>We are looking for the Flight Details for you...</p>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="loaderService.isLoading | async">
  <app-flight-result-loader></app-flight-result-loader>
</ng-container>

<section class="roundWayTrip itineraryMulti" *ngIf="!(loaderService.isLoading | async)">
  <owl-carousel-o [options]="itinerary">
    <ng-template carouselSlide *ngFor="let response of multiCityFlightData">
      <ng-container>
        <div class="roundTrip" *ngFor="let item of response.flightjourneys[0].flightlegs">
          <div class="wrapper">
            <div class="flightNameDate">
              <p>
                {{item[0].origin_name}}
                <img src="../../../../assets/svgIcon/arrow_long_right.svg" alt="Delhi Mumbai">
                {{item[item.length-1].destination_name}}
              </p>
              <p>{{item[0].arrdate | date : "MMM d, y"}}</p>
            </div>
            <div class="shorting">
              <div class="shortFirst">
                <button mat-button>Sort By:</button>
              </div>
              <div class="shortMiddle">
                <div class="middleFirst">
                  <button mat-button>Depart</button>
                </div>
                <div class="middleSecond">
                  <button mat-button>Duration</button>
                </div>
                <div class="middleThird">
                  <button mat-button>Arrive</button>
                </div>
              </div>
              <div class="shortSecondLast">
                <button mat-button>Price<mat-icon class="material-icons">arrow_upward</mat-icon></button>
              </div>
            </div>
          </div>
        </div>
        <section class="itinerarySction roundWayItinerary">
          <div class="roundTripCol">
            <mat-card *ngFor="let item of response.flightjourneys" [ngClass]="{'selected': selectedItem == item}"
              (click)="select(item)">
              <div matRipple matRippleCentered [ngClass]="{'selected': selectedItem == subItem}"
                *ngFor="let subItem of item['flightlegs']">
                <div class="flightInformation">
                  <div class="flightInfo web_view">
                    <img [src]="subItem[0].carrierImage ? subItem[0].carrierImage : '../../../assets/main/IG_07.png'"
                      [alt]="subItem[0].carriername" class="img-fluid">
                    <div class="carrierInfo">
                      <p class="carriername">{{subItem[0].carriername}}</p>
                      <p class="carrierNumber">{{subItem[0].carrier}}-{{subItem[0].flightnumber}}
                        <span *ngIf="subItem.length === 2"
                          class="stopageVia">,<br>{{subItem[1].carrier}}-{{subItem[1].flightnumber}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="flightTimeInfo">
                    <div class="middleFirst">
                      <p>{{subItem[0].deptime}}<br><span>{{subItem[0].origin_name.slice(0, -5)}}</span></p>
                    </div>
                    <div class="middleSecond">
                      <div class="timeDuration">
                        <p *ngIf="subItem.length === 1">{{subItem[0].journeyduration * 1000 * 60 | date: 'HH:mm' :
                          'UTC'}}
                        </p>
                        <p *ngIf="subItem.length === 2">{{subItem[0].journeyduration + subItem[1].journeyduration * 1000
                          *
                          60 | date: 'HH:mm' : 'UTC'}}</p>
                        <div class="distanceLine">
                          <span></span>
                          <span *ngIf="subItem.length === 2" class="stopagePoint"><span></span></span>
                        </div>
                        <ng-container>
                          <p *ngIf="subItem.length === 1" class="stopageVia">Non Stop</p>
                          <p *ngIf="subItem.length === 2" class="stopageVia">1 stop via
                            {{subItem[1].origin_name.slice(0, -5)}}</p> <br>
                          <p *ngIf="subItem.length === 3" class="stopageVia">2 stop via
                            {{subItem[2].origin_name.slice(0, -5)}}</p>
                        </ng-container>
                      </div>
                    </div>
                    <div class="middleThird">
                      <!-- {{subItem | json}} -->
                      <ng-container>
                        <p *ngIf="subItem.length === 1">
                          {{subItem[0].arrtime}}<br><span>{{subItem[0].destination_name.slice(0, -5)}}</span></p>
                        <p *ngIf="subItem.length === 2">
                          {{subItem[1].arrtime}}<br><span>{{subItem[1].destination_name.slice(0, -5)}}</span></p>
                      </ng-container>
                    </div>
                  </div>
                  <div class="flightTotlalPrice">
                    <p>{{item.flightfare.totalnet | currency: 'INR': true : '2.0-0' }}</p>
                  </div>
                </div>

                <div class="itineraryDetail">
                  <div class="flightInformation">
                    <div class="flightInfo mobile_view">
                      <img [src]="subItem[0].carrierImage ? subItem[0].carrierImage : '../../../assets/main/IG_07.png'"
                        [alt]="subItem[0].carriername" class="img-fluid">
                      <div class="carrierInfo">
                        <p class="carriername">{{subItem[0].carriername}}</p>
                        <p class="carrierNumber">{{subItem[0].carrier}}-{{subItem[0].flightnumber}}
                          <span *ngIf="subItem.length === 2"
                            class="stopageVia">,<br>{{subItem[1].carrier}}-{{subItem[1].flightnumber}}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="itineraryInfo">
                    <div class="extraInfo">
                      <ul>
                        <li class="baggage">
                          <mat-icon>luggage</mat-icon>&nbsp;
                          <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                            {{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)</ng-container>
                          <ng-container *ngIf="item?.extra_info?.baggage?.length === 0"><span>No check-in luggage</span>
                          </ng-container>
                        </li>
                        <!-- Food Meal -->
                        <li class="meal">
                          <ng-container *ngIf="item?.extra_info?.change?.length !== 0">
                            <mat-icon>restaurant</mat-icon>&nbsp;{{item.extra_info.change[0].value}}
                          </ng-container>
                          <ng-container *ngIf="item?.extra_info?.change?.length === 0"><span>
                              <mat-icon>no_meals</mat-icon>&nbsp;No Meal
                            </span>
                          </ng-container>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <button mat-button (click)="selectFistTrip(item)">Flight Details</button>
                </div>
                <section class="flightDetailsSection" [ngClass]="{'d-block': selectedFistTrip == item}">
                  <div class="flightMoreDeatiles tabsFlightMore">
                    <mat-tab-group dynamicHeight mat-align-tabs="start">
                      <mat-tab label="Flight Details">
                        <ng-template matTabLabel>Flight Details</ng-template>
                        <ng-template matTabContent>
                          <div class="innerWrapper">
                            <ng-container *ngFor="let subItem of item['flightlegs']['0']">
                              <div class="flightItinerary">
                                <div class="flightDitels">
                                  <div class="flightInfo">
                                    <img
                                      [src]="subItem?.carrierImage ? subItem?.carrierImage : '../../../assets/main/IG_07.png'"
                                      [alt]="subItem.carriername" class="img-fluid">
                                    <div class="carrierInfo">
                                      <p class="carriername">
                                        <span>{{subItem.carriername}}</span>&nbsp;({{subItem.cabinclass}})
                                      </p>
                                      <p>{{subItem.carrier}}-{{subItem.flightnumber}}</p>
                                    </div>
                                  </div>
                                  <div class="extraInfo">
                                    <p class="baggage">
                                      <mat-icon>luggage</mat-icon>&nbsp;
                                      <ng-container *ngIf="item?.extra_info?.baggage?.length !== 0">
                                        {{item.extra_info.baggage[0].value}}&nbsp;Check-In(1pc)</ng-container>
                                      <ng-container *ngIf="item?.extra_info?.baggage?.length === 0"><span>No check-in
                                          luggage</span>
                                      </ng-container>
                                    </p>
                                  </div>
                                </div>
                                <div class="detailsFlightAirport">
                                  <div class="flightInfoDetials">
                                    <p>{{subItem.origin_name.slice(0, -5)}}</p>
                                    <p class="time">{{subItem.deptime}}</p>
                                    <p class="date">{{subItem.depdate | date}}</p>
                                  </div>
                                  <div class="timeDuration">
                                    <p>{{subItem.journeyduration * 1000 * 60 | date: 'HH:mm' : 'UTC'}}</p>
                                    <span></span>
                                  </div>
                                  <div class="flightInfoDetials">
                                    <p>{{subItem.destination_name.slice(0, -5)}}</p>
                                    <p class="time">{{subItem.arrtime}}</p>
                                    <p class="date">{{subItem.arrdate | date}}</p>
                                  </div>
                                </div>
                                <p class="overLayStrip">Change of Planes | _________ layover in
                                  {{subItem.destination_name.slice(0, -5)}}</p>
                              </div>
                            </ng-container>
                          </div>
                        </ng-template>
                      </mat-tab>
                      <mat-tab label="Fare Summary">
                        <ng-template matTabLabel>Fare Summary</ng-template>
                        <ng-template matTabContent>
                          <div class="innerWrapper">
                            <div class="fareSummary">
                              <p>Base Fare<span>{{item.flightfare.adultbasefare | currency: 'INR': true : '2.0-0'
                                  }}</span>
                              </p>
                              <p>Fee & Surcharges<span>{{item.flightfare.adulttax | currency: 'INR': true : '2.0-0'
                                  }}</span>
                              </p>
                              <p>Other Services<span>0</span></p>
                              <p>Total Amount<span>{{item.flightfare.totalnet | currency: 'INR': true : '2.0-0'
                                  }}</span></p>
                            </div>
                          </div>
                        </ng-template>
                      </mat-tab>
                      <mat-tab label="Fare Rules">
                        <ng-template matTabLabel>Fare Rules</ng-template>
                        <ng-template matTabContent>
                          <div class="innerWrapper">
                            <h4>Fare Rules</h4>
                            <div class="fareRules">
                              <h5>Airline Cancellation Fee</h5>
                              <h6>Duration<span>Per Passenger</span></h6>
                              <p>0-2 hours<span>Non-Refundable</span></p>
                              <p>2h-4days<span>3,500</span></p>
                              <p>>4days<span>3,000</span></p>
                            </div>
                            <div class="fareRules">
                              <h5>Airline Date Change Fee</h5>
                              <h6>Duration<span>Per Passenger</span></h6>
                              <p>2h-4days<span>3,500</span></p>
                              <p>>4days<span>3,000</span></p>
                            </div>
                          </div>
                        </ng-template>
                      </mat-tab>
                    </mat-tab-group>
                  </div>
                </section>
              </div>
            </mat-card>
          </div>
        </section>
      </ng-container>
    </ng-template>
  </owl-carousel-o>
</section>
<ng-container *ngIf="!multiCityFlightData || (multiCityFlightData && multiCityFlightData.length === 0)">
  <div class="no_results-wrapper">
    <mat-card>
      <div class="error-wrapper text-center">
        <div class="no-results-img d-flex justify-content-center">
          <img src="../../../assets/b2c/flight/multi-result-not-found.png" class="img-fluid">
        </div>
        <h1>No results found</h1>
        <p>
          Sorry! We could not find any flight for this search. Please search again
        </p>
        <div class="search_btn">
          <button mat-button class="secoundaryBtn">Search again</button>
        </div>

      </div>
    </mat-card>
  </div>
</ng-container>